import { metaKey } from '~/scripts/utils';

export default async ({ $api, app, $cookies, redirect, route, store }) => {
  const id = $cookies.get('bonkers-ie-car-insurance-search');
  const vehicle = $cookies.get('bonkers-ie-car-insurance-capture-point');
  const uuid = route.params.uuid;
  const params = {};
  const searchRequired = metaKey(route, 'searchRequired');

  if (!id && !uuid) {
    if (searchRequired) {
      return redirect(301, app.localePath('/compare-car-insurance/'), {
        flashClass: 'error',
        flashMessage: store.$i18n.t('errors.carInsuranceSearchNotFound')
      });
    }
    if (vehicle) {
      store.commit('search/set', { vehicle });
    } else {
      store.commit('search/reset', { type: 'carInsurance' });
    }
    return;
  }

  if (uuid && !id) {
    // coming from reminder email - fetch after customer confirming DOB and ref code
    return;
  }

  if (metaKey(route, 'removeAddons')) {
    params.remove_addons = true;
    store.commit('products/clear');
  }

  await $api(`protection/motor_insurance_searches/${uuid || id}`, params).then(search => {
    $cookies.set('bonkers-ie-car-insurance-search', search.id);
    store.commit('products/setList', search.quotes);
    if (params.remove_addons !== undefined && search.addons && search.addons.length > 0) {
      if (search.addons.some(add => add.active === true)) {
        store.commit('products/clear');
      }
    }
    if (!search.vehicle) {
      search.vehicle = vehicle;
    }
    delete search.quotes;
    store.commit('search/reset', { type: 'carInsurance', search });
    store.commit('search/setTemp', { claims_excess: 250 });
    route.meta[0] = { ...route.meta[0], ...{ jumbotronParams: { amount: store.$i18n.n(search.contents_cover, 'currencyRound') } } };
  }).catch(e => {
    if (uuid && e.response.status === 404) {
      route.meta[0] = { ...route.meta[0], ...{ jumbotronScope: 'compare-car-insurance.confirm-search' } };
      return;
    }
    $cookies.remove('bonkers-ie-car-insurance-search');
    store.commit('search/reset', { type: 'carInsurance' });
  });
};
